import { getPermissionsState } from './../roles.selectors'
import { FetchPermissionsRequest } from './../roles.actions'
import Validator from '@shared/validatorjs/src/validator'
import {
  UpdateField,
  SetDefaultData,
  CreateRoleRequest,
} from '../roles.actions'
import { getCreateRoleState } from '../roles.selectors'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Subscription, Observable } from 'rxjs'
import { Map, List } from 'immutable'
import { groupPermissions } from '@shared/shared.utils'

@Component({
  selector: 'app-create-role',
  templateUrl: './create-role.component.html',
  styleUrls: ['./create-role.component.css'],
})
export class CreateRoleComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public permissions$: Subscription
  private state$: Subscription
  public isLoading: boolean
  public permissionGroups: any[] = []

  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('createRole'))
    this.state$ = this.store
      .pipe(select(getCreateRoleState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.permissions$ = this.store
      .pipe(select(getPermissionsState))
      .subscribe((state) => {
        this.permissionGroups = groupPermissions(state.get('data').toJS())
      })

    this.store.dispatch<any>(new FetchPermissionsRequest())
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.permissions$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target.name,
        name ? e : e.target.value,
        'createRole.data',
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'createRole',
      ),
    )
  }

  public checkboxChange(e: any): void {
    let permissions = (this.state.getIn(['data', 'permissions']) as any).toJS()

    if (e.target.checked) {
      permissions.push(e.target.value)
    } else {
      permissions = permissions.filter(
        (perm: string) => perm !== e.target.value,
      )
    }

    this.store.dispatch(
      new UpdateField('permissions', permissions, 'createRole.data'),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      name: 'required',
      title: 'required',
    }
    const validator = new Validator(data.toJS(), rules)

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()
    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(new CreateRoleRequest(payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'createRole',
        ),
      )
    }
  }
}
